const base = require("./base");
module.exports = {
  ...base.apiFactory(),
};
